// Import all option template files
// No exports needed - templates self-register with TemplateRegistry

import './hidden.option.js';
import './value-formula.option.js';
import './text.option.js';
import './textarea.option.js';
import './text-editor.option.js';
import './date.option.js';
import './number.option.js';
import './dimension.option.js';
import './email.option.js';
import './radio.option.js';
import './checkbox.option.js';
import './select.option.js';
import './country.option.js';
import './dropdown.option.js';
import './color.option.js';
import './color-input.option.js';
import './img-swatch.option.js';
import './button-swatch.option.js';
import './view-switch.option.js';
import './color-swatch.option.js';
import './color-img-swatch.option.js';
import './font.option.js';
import './html.option.js';
import './price-summary.option.js';
import './group.option.js';
import './tabs.option.js';
import './quantity-discount.option.js';
import './quantity.option.js';
import './personalize.option.js';
import './download.option.js';
import './layer-editor.option.js';
import './upload.option.js';
import './upload-lift.option.js';
import './library.option.js';
import './bundle.option.js';
import './ai.option.js';
import './group-editor.option.js';
import './save-config.option.js';
import './saved-configs.option.js';